import { useNavigate, useParams } from 'react-router-dom'
import useAPI from '~/prix/react/hooks/api'
import MessageList from '~/components/llm/messageList'
import ChatTitle from '~/components/llm/chatTitle'
import { Tooltip } from 'react-tooltip'
import llmChatGetDefinition from './llmChatGet.definition'
import useAction from '~/prix/react/hooks/action'
import { useEffect, useMemo } from 'react'
import MessageSkeleton from '~/components/llm/messageSkeleton'
import styled from 'styled-components'
import { useLlmChatContext } from '~/components/llm/llmChatContext'

const MessagesArea = styled.div`
  flex: 1;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;

  @media screen and (max-width: 1150px) {
    padding: 0px 10px;
  }
`

const InputSection = styled.div`
  position: sticky;
  bottom: 0px;
  width: 100%;
  padding-bottom: 20px;
  z-index: 1;
  background: rgba(235, 235, 235, 1);
  box-shadow: 0 0px 30px 30px rgba(235, 235, 235, 1);

  @media screen and (max-width: 1150px) {
    padding: 0px 10px 10px;
  }
`

const InputSectionContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`

export default function GeneralLlmChatGetScreen({ isArchived = false }: { isArchived?: boolean }) {
  const api = useAPI()
  const { chatId } = useParams()
  const chatIdNumber = parseInt(chatId ?? '-1')
  const navigate = useNavigate()

  const { chatList } = useLlmChatContext()

  const currentChatFromList = useMemo(() => {
    return chatList.find(chat => chat.id === chatIdNumber)
  }, [chatList, chatId])

  const { result: chatHistoryResult, isLoading: isLoadingChatHistory } = useAction(
    llmChatGetDefinition,
    { id: chatIdNumber },
    [chatId, api.isLoading, api.context.user],
    {
      autoLoad: !api.isLoading && !!api.context.user,
      staleWhileRevalidate: true,
      onError: error => {
        navigate('/app/ai')
      },
    },
  )

  useEffect(() => {
    if (!chatHistoryResult) return

    //redireciona para o link correto
    if (chatHistoryResult?.archivedAt && !isArchived) {
      navigate(`/app/ai/archived/${chatIdNumber}`)
    }

    if (!chatHistoryResult?.archivedAt && isArchived) {
      navigate(`/app/ai/${chatIdNumber}`)
    }
  }, [chatHistoryResult, isArchived, chatIdNumber, navigate])

  const currentChat = useMemo(() => {
    return { ...chatHistoryResult, title: currentChatFromList?.title ?? chatHistoryResult?.title }
  }, [chatHistoryResult, currentChatFromList?.title])

  return (
    <>
      {isLoadingChatHistory ? (
        <>
          <ChatTitle chatId={-1} isFixed={false} isArchived={false}>
            Carregando...
          </ChatTitle>
          <MessagesArea>
            <MessageSkeleton />
          </MessagesArea>
        </>
      ) : (
        <>
          <ChatTitle
            chatId={chatIdNumber}
            isFixed={currentChat?.isFixed ?? false}
            isArchived={currentChat?.archivedAt !== null}
          >
            {currentChat?.title ?? 'Chat sem título'}
          </ChatTitle>
          <MessageList
            chatId={chatIdNumber}
            firstMessage={currentChat?.title ?? undefined}
            isArchived={currentChat?.archivedAt !== null}
            historyMessages={currentChat?.messages ?? []}
          />
        </>
      )}
      <Tooltip id='tooltip-bubble-action' place='bottom' style={{ zIndex: 10 }} />
    </>
  )
}
